export default {"src":"/_next/static/media/icon-right-arrow.e724f296.svg","height":25,"width":25};